import { select, selectAll, on, getData, trigger } from 'modules/dom'
import { addQueryVar, getQueryVar, map } from 'modules/utils'

const VIEW_SELECTOR = '.js-view-type'
const CALENDAR_VIEW_SELECTOR = '.js-calendar-select'
const CALENDAR_TITLE_SELECTOR = '.js-calendar-title'

export default (el) => {
  let pageUrl = window.location.href
  const viewButtons = selectAll(VIEW_SELECTOR, el)
  const selectElm = select(CALENDAR_VIEW_SELECTOR, el)
  const calendarTitle = select(CALENDAR_TITLE_SELECTOR, el)

  let params = {
    view: getQueryVar('view'),
    'view-by': getQueryVar('view-by'),
    currentStart: getQueryVar('currentStart'),
    activeStart: getQueryVar('activeStart'),
    activeEnd: getQueryVar('activeEnd')
  }

  const updateViewAndRedirect = (view) => {
    if (!view) {
      return false
    }
    params = {
      view: view,
      'view-by': getQueryVar('view-by'),
      currentStart: getData('current', calendarTitle),
      activeStart: getData('start', calendarTitle),
      activeEnd: getData('end', calendarTitle)
    }
    redirectToNewPage()
  }

  const generateUrl = (url) => {
    map(key => {
      url = addQueryVar(key, params[key], url)
    }, Object.keys(params))

    return url
  }

  const redirectToNewPage = () => {
    if (pageUrl) {
      const newUrl = generateUrl(pageUrl)
      if (newUrl) {
        window.location.href = newUrl
      }
    }
  }

  // handle button change view grid, list
  if (viewButtons) {
    on('click', (e) => {
      const viewType = getData('view-type', e.target)
      if (viewType) {
        e.preventDefault()
        updateViewAndRedirect(viewType)
      }
    }, viewButtons)
  }
}
